const audio_ctx = new AudioContext();

export { audio_ctx };